'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getDateParts = function (fd, time) {
    var parts = fd(time, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        weekday: 'short',
    });
    var weekday = parts[0], month = parts[2], day = parts[4], year = parts[6], hour = parts[8], minute = parts[10], dayPeriod = parts[12];
    return {
        weekday: weekday.value,
        year: year.value,
        month: month.value,
        day: day.value,
        hour: hour.value,
        minute: minute.value,
        dayPeriod: dayPeriod.value,
    };
};
var formatAppointmentTime = function (fm, fd, start, end) {
    var startParts = getDateParts(fd, start);
    var dayWithOrdinal = fm({ id: 'componentLib.appWide.ordinal' }, { day: startParts.day });
    var formattedTime = startParts.weekday + " " + startParts.month + " " + dayWithOrdinal + ", " + startParts.year + " " + startParts.hour + ":" + startParts.minute + " " + startParts.dayPeriod;
    if (end) {
        var endParts = getDateParts(fd, end);
        formattedTime = formattedTime + " - " + endParts.hour + ":" + endParts.minute + " " + endParts.dayPeriod;
    }
    return formattedTime;
};
var formatAppointmentTimeCompact = function (fm, fd, ft, start) {
    var atString = fm({ id: 'componentLib.appWide.at' });
    var formattedTime = fd(start, {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
    }) + " " + atString + " " + ft(start);
    return formattedTime;
};

exports.formatAppointmentTime = formatAppointmentTime;
exports.formatAppointmentTimeCompact = formatAppointmentTimeCompact;
